<div class="web">
  <div
    #footer
    class="footer-fixed"
    [ngClass]="{ 'hidden-footer': !showFooter }"
  >
    <footer class="page-footer font-small fondoFooter">
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0;
          padding: 0;
        "
      >
        <div style="display: flex; margin: 0; padding: 0" class="footercenter">
          <div style="flex: 0 0 33%">
            <div class="container">
              <div class="row">
                <div class="col-sm-12" style="font-size: 17px">
                  <p>
                    <img src="/assets/image/logo-editora.png" width="181" />
                  </p>
                  <div
                    style="
                      margin-top: 5px;
                      line-height: 1.2;
                      white-space: nowrap;
                    "
                  >
                    Editora Perú Av. Alfonso Ugarte 873, Lima 1<br />
                    Central Telefónica (51-1) 3150400 <strong>Anexos: 3361, 3360, 3350 y 3351</strong><br />
                    Empresa Peruana de Servicios Editoriales - <strong>Editora Perú </strong><br />
                    RUC <strong>2010007251</strong><br />
                  </div>
                </div>
              </div>
            </div>
          </div>

<!-- Columna 2: Términos y Política -->
<div
  style="
    flex: 0 0 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  "
>
  <div style="margin-bottom: 10px">
    <a [routerLink]="['/terminos-condiciones']"   class="footer-link">
      Términos y Condiciones
    </a>
  </div>
  <div>
    <a href="https://www.editoraperu.com.pe/PrivacidadEP/Politica_Proteccion_Datos_Personales.pdf"  target="_blank" class="footer-link">
      Política de Privacidad
    </a>
  </div>
</div>


          <div
            style="
              flex: 0 0 33%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            "
          >
            <!-- Libro de Reclamaciones -->
            <div >
              <a
                href="https://www.editoraperu.com.pe/EditoraP/LibroReclamaciones.html#!"
                target="_blank"
                title="Libro de Reclamaciones"
              >
                <img
                  src="/assets/image/libro-reclamaciones2.png"
                  alt="Libro de Reclamaciones"
                  width="80"
                />
              </a>
            </div>

            <!-- Redes sociales -->
            <!-- Redes sociales -->
            <div>
              <table>
                <tr>
                  <td
                    class="text-center"
                    colspan="8"
                    style="padding: 10px 0; text-align: center"
                  >
                    Visítanos en:
                  </td>
                </tr>

                <!-- Fila 1 -->
                <tr>
                  <td style="padding-right: 12px">
                    <a
                      href="https://www.facebook.com/diariooficialelperuano"
                      target="_blank"
                      aria-label="Facebook"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-facebook"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 12px">
                    <a
                      href="https://www.instagram.com/diarioelperuano/"
                      target="_blank"
                      aria-label="Instagram"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-instagram"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 12px">
                    <a
                      href="https://www.linkedin.com/company/elperuano/"
                      target="_blank"
                      aria-label="LinkedIn"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-linkedin"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 12px">
                    <a
                      href="https://x.com/DiarioElPeruano"
                      target="_blank"
                      aria-label="X"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-twitter-x"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <!-- Fila 2 -->

                  <td style="padding-right: 12px">
                    <a
                      href="https://www.youtube.com/@elperuanooficial"
                      target="_blank"
                      aria-label="YouTube"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-youtube"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 12px">
                    <a
                      href="https://open.spotify.com/show/3XRNfOBL0cwFr7DpGuVtcl"
                      target="_blank"
                      aria-label="Spotify"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-spotify"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 12px">
                    <a
                      href="https://www.tiktok.com/@diarioelperuano"
                      target="_blank"
                      aria-label="TikTok"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-tiktok"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 12px">
                    <a
                      href="https://whatsapp.com/channel/0029Va5DnSb05MUmn4Mx0S0e"
                      target="_blank"
                      aria-label="WhatsApp"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-whatsapp"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="fondoFooter2">
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-md-0 mb-3 mt-3">
            <p class="text-center fontCopy">© 2025 Copyright; Editora Perú</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="movil">
  <div
    #footer
    class="footer-fixed"
    [ngClass]="{ 'hidden-footer': !showFooter }"
  >
    <footer class="page-footer font-small fondoFooter">
      <div
        class="container-fluid text-center text-md-left"
        style="margin-bottom: 15px"
      >
        <div class="row">
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
          >
            <!-- Libro de Reclamaciones -->
            <div style="margin-bottom: 15px">
              <a
                href="https://www.editoraperu.com.pe/EditoraP/LibroReclamaciones.html#!"
                target="_blank"
                title="Libro de Reclamaciones"
              >
                <img
                  src="/assets/image/libro-reclamaciones2.png"
                  alt="Libro de Reclamaciones"
                  width="80"
                />
              </a>
            </div>

            <!-- Redes sociales -->
            <div
              style="margin-top: 10px; display: flex; justify-content: center"
            >
              <table>
                <tr>
                  <td
                    class="text-center"
                    colspan="8"
                    style="padding: 10px 0; text-align: center"
                  >
                    Visítanos en:
                  </td>
                </tr>

                <!-- Fila 1 -->
                <tr>
                  <td style="padding-right: 6px">
                    <a
                      href="https://www.facebook.com/diariooficialelperuano"
                      target="_blank"
                      aria-label="Facebook"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-facebook"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 6px">
                    <a
                      href="https://www.instagram.com/diarioelperuano/"
                      target="_blank"
                      aria-label="Instagram"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-instagram"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 6px">
                    <a
                      href="https://www.linkedin.com/company/elperuano/"
                      target="_blank"
                      aria-label="LinkedIn"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-linkedin"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 6px">
                    <a
                      href="https://x.com/DiarioElPeruano"
                      target="_blank"
                      aria-label="X"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-twitter-x"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <!-- Fila 2 -->

                  <td style="padding-right: 6px">
                    <a
                      href="https://www.youtube.com/@elperuanooficial"
                      target="_blank"
                      aria-label="YouTube"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-youtube"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 6px">
                    <a
                      href="https://open.spotify.com/show/3XRNfOBL0cwFr7DpGuVtcl"
                      target="_blank"
                      aria-label="Spotify"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-spotify"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 6px">
                    <a
                      href="https://www.tiktok.com/@diarioelperuano"
                      target="_blank"
                      aria-label="TikTok"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-tiktok"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>

                  <td style="padding-right: 6px">
                    <a
                      href="https://whatsapp.com/channel/0029Va5DnSb05MUmn4Mx0S0e"
                      target="_blank"
                      aria-label="WhatsApp"
                    >
                      <span
                        class="d-inline-flex align-items-center justify-content-center rounded-circle border"
                        style="width: 40px; height: 40px"
                      >
                        <i
                          class="bi bi-whatsapp"
                          style="font-size: 22px; line-height: 1"
                        ></i>
                      </span>
                    </a>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="container" style="text-align: center">
        <div class="row">
          <div class="col-sm-12" style="font-size: 12px">
            <p>
              <img src="/assets/image/logo-editora.png" width="181" />
            </p>
            <div style="margin-top: 5px; line-height: 1.2; white-space: nowrap">
                    Editora Perú Av. Alfonso Ugarte 873, Lima 1<br />
                    Central Telefónica (51-1) 3150400 <strong>Anexos: 3361, 3360, 3350 y 3351</strong><br />
                    Empresa Peruana de Servicios Editoriales - <strong>Editora Perú </strong><br />
                    RUC <strong>2010007251</strong><br />
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 15px; display: flex; flex-direction: column; align-items: center; text-align: center;">
        <div style="margin-bottom: 10px">
          <a [routerLink]="['/terminos-condiciones']" class="footer-link">
            Términos y Condiciones
          </a>
        </div>
        <div>
          <a href="https://www.editoraperu.com.pe/PrivacidadEP/Politica_Proteccion_Datos_Personales.pdf" target="_blank" class="footer-link">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>
    <div class="fondoFooter2">
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-md-0 mb-3 mt-3">
            <p class="text-center fontCopy">© 2025 Copyright; Editora Perú</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
